import React from "react";
import {
  Box,
  Container,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { hero } from "../components/SmallComponents/Images";
import { StyledNavButton } from "../components/SmallComponents/AppComponents";

function LandingHeroSection() {
  const matches = useMediaQuery("(max-width:1050px)");
  return (
    <Box mt={8} mb={{ xs: 1, md: 0 }} id="home">
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 2, sm: 4 }}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box mt={{ xs: -2, sm: 0, md: 0 }}>
              <Typography
                sx={{
                  fontFamily: "Lilita One",
                  fontSize: { xs: "55px", sm: "86px" },
                  color: "#fff",
                  textAlign: { xs: "center", md: "left" },
                  WebkitTextStroke: "3px #65CD2E",
                }}
              >
                {/* Launching */}
                Welcome to
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Lilita One",
                  fontSize: { xs: "55px", sm: "86px" },
                  lineHeight: { xs: "40px", sm: "30px" },
                  textAlign: { xs: "center", md: "left" },
                  color: "#65CD2E",
                  WebkitTextStroke: "3px #ffffff",
                }}
              >
                BARFBOY
              </Typography>

              <Stack
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
                // mt={1}
                mt={{ xs: 4, sm: 6 }}
              >
                <Typography
                  sx={{
                    fontFamily: "Lilita One",
                    fontSize: { xs: "20px", sm: "22px" },

                    textAlign: { xs: "center", md: "left" },
                    color: "#fff",
                    WebkitTextStroke: "0.5px black",
                    textShadow:
                      "-0.8px -0.8px 0 #0B0A26, 0.8px -0.8px 0 #0B0A26, -0.8px 0.8px 0 #0B0A26, 0.8px 0.8px 0 #0B0A26",
                  }}
                >
                  Bringing BARFBOY to the crypto World!
                </Typography>
              </Stack>
              <Stack
                // mt={2}
                mt={4}
                flexDirection={{ xs: "column", sm: "row" }}
                alignItems={"center"}
                gap={{ xs: 3, sm: 1.5 }}
              >
                <StyledNavButton
                  href="https://raydium.io/swap/?inputMint=sol&outputMint=mVuzEMo5n4p6iHNFGWsFkACB2F1vNmW8BdwoyKApump"
                  target="_blank"
                  width="220px"
                  bgColor="linear-gradient(180deg, #74A1FF 0%, #2E72FF 100%)"
                >
                  Buy BARFBOY
                </StyledNavButton>
                {/* </Link> */}
                <StyledNavButton
                  href="https://stake.barfboymemecoin.com/"
                  target="_blank"
                  width={{ xs: "220px", sm: "170px" }}
                >
                  Stake BARFBOY
                </StyledNavButton>
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box display="flex" justifyContent="flex-end">
              <Box component={"img"} alt="" src={hero} width={"100%"} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default LandingHeroSection;
